/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface Servizio { 
    id?: string;
    comune_id?: string;
    comune_nome?: string;
    comune_slug?: string;
    tipo_pagamento?: ServizioTipoPagamentoEnum;
}
export enum ServizioTipoPagamentoEnum {
    NON_GESTITO = 'NON_GESTITO',
    MANUALE = 'MANUALE',
    PAGO_PA_RICARICHE = 'PAGO_PA_RICARICHE',
    PAGO_PA_RENDICONTAZIONE_E_RICARICHE = 'PAGO_PA_RENDICONTAZIONE_E_RICARICHE',
    PAGO_PA_RENDICONTAZIONE = 'PAGO_PA_RENDICONTAZIONE'
};



